import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterInspections = (inspections, filters) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit ? inspections.slice(filterOffset, filterLimit) : inspections.slice(filterOffset)

  return limited
}

const renderInspections = (inspections, inspectionContainer) => inspections.map(inspection => (
  <div key={inspection.id} style={deviceStyle(inspectionContainer)}>
    <ElementContainer
      forwardContextToItems={inspection}
      section={inspectionContainer}
      renderNested
      render={({ itemComponents }) => itemComponents.map(component => component)}
    />
  </div>
))

const CampaignInspections = (props) => {
  const { items, options } = props

  const { limit, offset } = options || {}

  const inspectionContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { campaignInspections } = defaultContext

  const filteredInspections = filterInspections(campaignInspections, {
    limit,
    offset,
  })

  return (
    <AnimationWrapper options={options}>
      <div style={style}>
        {renderInspections(filteredInspections, inspectionContainer)}
      </div>
    </AnimationWrapper>
  )
}

CampaignInspections.propTypes = {
  items: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
}

export default CampaignInspections
